import { useToast } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useFetchProfileQuery } from 'rtkQuery/sharespro/queries/profile';

import PhoneConfirmationModal from 'presentation/components/shared/modals/PhoneConfirmationModal';
import {
  useRequestRebalancingConfirmationMutation,
  useVerifyRebalanceConfirmationMutation,
} from 'rtkQuery/sharespro/queries/home';

interface Props {
  isOpen: boolean;
  id: number;
  onClose: () => void;
}

const ConfirmAllRebalancingModal: FC<Props> = ({ isOpen, onClose, id }) => {
  const { data } = useFetchProfileQuery();

  const [verifyOtp, { isLoading }] = useVerifyRebalanceConfirmationMutation();

  const toast = useToast();

  const { t } = useTranslation();

  const [requestOrderConfirmation, { isLoading: newCodeRequesting }] =
    useRequestRebalancingConfirmationMutation();

  return (
    <PhoneConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('orderConfirmation')}
      text={t('codeHasBeenSentToNumber')}
      phoneNumber={data?.phone ?? null}
      onSubmit={async (values) => {
        await verifyOtp({ otpId: values.otpId, code: values.code })
          .unwrap()
          .then(() => {
            onClose();
            toast({
              description: t('allOrdersHaveBeenApproved'),
              status: 'success',
              position: 'top-right',
              isClosable: true,
            });
          });
      }}
      otpVerifying={isLoading}
      onSendNewCode={async () => {
        const resp = await requestOrderConfirmation(id).unwrap();

        return resp;
      }}
      newCodeRequesting={newCodeRequesting}
    />
  );
};

export default ConfirmAllRebalancingModal;
